import React from 'react';
import { motion } from 'framer-motion';

const CARD_INITIAL = { opacity: 0, y: 30 };
const CARD_VISIBLE = { opacity: 1, y: 0 };
const CARD_HOVER = { y: -10 };

const ICON_HOVER = { rotate: 360, scale: 1.1 };
const ICON_TRANSITION = { duration: 0.6 };

const ServiceCard = ({ service, idx, isInView }) => {
  const Icon = service.icon;
  const cardTransition = { delay: idx * 0.1, duration: 0.6 };

  return (
    <motion.div
      initial={CARD_INITIAL}
      animate={isInView ? CARD_VISIBLE : CARD_INITIAL}
      transition={cardTransition}
      whileHover={CARD_HOVER}
      className="group relative"
      data-testid={`service-card-${service.id}`}
    >
      <div className="relative h-full p-8 rounded-2xl bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm border border-white/10 hover:border-white/20 transition-all duration-300 overflow-hidden">
        {/* Hover Gradient Background */}
        <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-300`} />

        {/* Icon */}
        <motion.div
          whileHover={ICON_HOVER}
          transition={ICON_TRANSITION}
          className={`relative inline-flex p-4 rounded-xl bg-gradient-to-br ${service.gradient} mb-6 shadow-lg`}
        >
          <Icon className="w-8 h-8 text-white" />
        </motion.div>

        {/* Content */}
        <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:bg-clip-text group-hover:from-orange-400 group-hover:to-blue-400 transition-all">
          {service.title}
        </h3>
        <p className="text-gray-400 leading-relaxed">
          {service.description}
        </p>

        {/* Glow Effect */}
        <div className={`absolute -bottom-20 -right-20 w-40 h-40 bg-gradient-to-br ${service.gradient} rounded-full blur-3xl opacity-0 group-hover:opacity-20 transition-opacity duration-300`} />
      </div>
    </motion.div>
  );
};

export default ServiceCard;
